import { GET_OFFERS_DATA } from '@/store/modules/offersModule';

export default {
    computed: {
        offersData(this: any) {
            return this.$store.getters.getOffersData;
        },
        offerId(this: any) {
            // eslint-disable-next-line
            return this.$store.getters.getOffersData._id;
        },
        compCode(this: any) {
            return this.$store.getters.getOffersData.customer.id;
        },
        speakerName: {
            get(this: any) {
                const { contact } = this.$store.getters.getOffersData.customer;
                return `${contact.name} ${contact.surname}`;
            },
            set(this: any) { },
        },
        offerPayloads(this: any) {
            return this.$store.getters.getOfferPayloads;
        },
        pickerOptions(this: any) {
            return {
                firstDayOfWeek: 1,
            };
        },
    },

    methods: {
        remainFilters(this: any) {
            const filtrcheck = localStorage.getItem('offerSearchFilter');
            if (filtrcheck) {
                const selectedFilters = JSON.parse(localStorage.getItem('offerSearchFilter')!);
                this.formDats = selectedFilters;
                this.transForm();
                return;
            }
            this.$store.dispatch(GET_OFFERS_DATA);
        },
    },
};
